import { createElement, forwardRef, useMemo } from "react";
import {
  Link as RouterLink,
  useNavigate,
  useLocation,
  useParams,
  useSearchParams as useRouterSearchParams,
} from "react-router-dom";

export { useParams };

export const Link = forwardRef(function Link({ href, to, ...props }, ref) {
  return createElement(RouterLink, { ref, to: to ?? href, ...props });
});

export function useSearchParams() {
  const [searchParams] = useRouterSearchParams();
  return searchParams;
}

export function useRouter() {
  const navigate = useNavigate();
  return useMemo(
    () => ({
      /**
       * @param {string} href
       * @param {import('react-router-dom').NavigateOptions} [options] - React Router options (`replace`, `state`, etc.). Next.js-style `{ scroll: false }` is not supported and is ignored if passed; omit it.
       */
      push: (href, options = {}) => navigate(href, options),
      /**
       * @param {string} href
       * @param {import('react-router-dom').NavigateOptions} [options]
       */
      replace: (href, options = {}) =>
        navigate(href, { ...options, replace: true }),
      back: () => navigate(-1),
    }),
    [navigate]
  );
}

export function usePathname() {
  return useLocation().pathname;
}
